module.exports = __webpack_public_path__ + "img/hand-chart.61bf7105.svg";